import ClientNotes from './ClientNotes'

export default ClientNotes
